module.exports = __webpack_public_path__ + "static/media/newsletter-december-2022-10.fc180d39.jpg";